// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const PlusLarge_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 12a.75.75 0 0 1-.75.75h-7.5v7.5a.75.75 0 0 1-1.5 0v-7.5h-7.5a.75.75 0 0 1 0-1.5h7.5v-7.5a.75.75 0 0 1 1.5 0v7.5h7.5A.75.75 0 0 1 21 12Z',
  viewBox: '0 0 24 24',
  glyph: 'PlusLarge_Stroke2_Corner0_Rounded',
})

export const PlusSmall_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 12a.75.75 0 0 1-.75.75h-7.5v7.5a.75.75 0 0 1-1.5 0v-7.5h-7.5a.75.75 0 0 1 0-1.5h7.5v-7.5a.75.75 0 0 1 1.5 0v7.5h7.5A.75.75 0 0 1 21 12Z',
  viewBox: '0 0 24 24',
  glyph: 'PlusSmall_Stroke2_Corner0_Rounded',
})
